export const SET_ORGANIZATION = "SET_ORGANIZATION";
export const SET_ORGANIZATION_SUMMARY = "SET_ORGANIZATION_SUMMARY";
export const SET_ORGANIZATION_TEST_SUMMARY = "SET_ORGANIZATION_TEST_SUMMARY";
export const SET_ORGANIZATION_REPORTS = "SET_ORGANIZATION_REPORTS";
export const SET_GROUP = "SET_GROUP";
export const SET_GROUP_SUMMARY = "SET_GROUP_SUMMARY";
export const SET_GROUP_TEST_SUMMARY = "SET_GROUP_TEST_SUMMARY";
export const SET_SHOW_INACTIVE = "SET_SHOW_INACTIVE";
export const RESET_ORG_STATE = "RESET_ORG_STATE";
export const RESET_STATE = "RESET_STATE";